import { useState } from "react";
import { Apis } from "../../lib/Apis";

// --- Hook from InteriorDesign/useHook.js ---
export const useInteriorDesign = () => {
    const getInteriorDesign = async (setInteriorDesignData, setTotal, offset = 0, limit = 10, searchFilter = "", category_name = "") => {
        try {
            const params = {};
            if (searchFilter) {
                params.searchFilter = searchFilter;
            }
            if (category_name) {
                params.category_name = category_name;
            }
            const response = await Apis.getInteriorDesign(offset, limit, params);
            if (response?.status === 200) {
                setInteriorDesignData(response.data.data);
                const totalRecords = response.data.pagination?.totalRecords || response.data.data.length;
                setTotal(totalRecords);
                return response.data;
            } else {
                throw new Error(response?.data?.message || "Failed to fetch interior designs.");
            }
        } catch (error) {
            console.error("Error fetching interior design:", error);
            throw error;
        }
    };

    const createInteriorDesign = async (data) => {
        try {
            const response = await Apis.createInteriorDesign(data);
            return response.data;
        } catch (error) {
            console.error("Error creating interior design:", error);
            throw error;
        }
    };

    const updateInteriorDesign = async (id, data) => {
        try {
            const response = await Apis.updateInteriorDesign(id, data);
            return response.data;
        } catch (error) {
            console.error("Error updating interior design:", error);
            throw error;
        }
    };

    const deleteInteriorDesign = async (id) => {
        try {
            const response = await Apis.deleteInteriorDesign(id);
            return response.data;
        } catch (error) {
            console.error("Error deleting interior design:", error);
            throw error;
        }
    };

    const getInteriorDesignById = async (id, setInteriorData) => {
        try {
            const response = await Apis.getInteriorDesignById(id);
            setInteriorData(response.data);
            return response.data;
        } catch (error) {
            console.error("Error fetching interior design by id:", error);
            throw error;
        }
    };
    const showInteriorDesignOnHomeScreen = async (interiorDesignId, homeScreen) => {
        try {
            const data = {
                interiorDesignId,
                homeScreen: homeScreen ? 1 : 0
            };
            const response = await Apis.addInteriorDesignToHomeScreen(data);
            return response;
        } catch (error) {
            console.error("Error updating home screen status:", error);
            return error;
        }
    };

    const updateInteriorDesignPosition = async (interiorDesignId, newPosition) => {
        try {
            const response = await Apis.updateInteriorDesignPosition({ interiorDesignId, newPosition });
            return response?.data;
        } catch (error) {
            console.error("Error updating interior design position:", error);
            throw error;
        }
    };

    return {
        getInteriorDesign,
        createInteriorDesign,
        updateInteriorDesign,
        deleteInteriorDesign,
        getInteriorDesignById,
        showInteriorDesignOnHomeScreen,
        updateInteriorDesignPosition,
    };
};

// --- Hook from InteriorDesignCategories/useHook.js ---
export const useInteriorDesignCategory = () => {
    const addInteriorDesignCategory = async (categoryData) => {
        try {
            const response = await Apis.addInteriorDesignCategory(categoryData);
            return response;
        } catch (error) {
            throw error;
        }
    };
    const getInteriorDesignCategories = async () => {
        try {
            const response = await Apis.getInteriorDesignCategories();
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    const getInteriorDesignCategoriesWithPagination = async (offset = 0, limit = 10, name = "", status = "") => {
        try {
            const params = {};
            if (name) {
                params.name = name;
            }
            if (status !== "") {
                params.status = status === "true" ? true : status === "false" ? false : status;
            }
            const response = await Apis.getInteriorDesignCategoriesWithPagination(offset, limit, params);
            return response.data;
        } catch (error) {
            throw error;
        }
    };
    const updateInteriorDesignCategory = async (id, categoryData) => {
        try {
            const response = await Apis.updateInteriorDesignCategory(id, categoryData);
            return response;
        } catch (error) {
            throw error;
        }
    };
    const deleteInteriorDesignCategory = async (categoryId) => {
        try {
            const response = await Apis.deleteInteriorDesignCategory(categoryId);
            return response;
        } catch (error) {
            throw error;
        }
    };
    const toggleInteriorDesignCategoryStatus = async (categoryId, status) => {
        try {
            const response = await Apis.toggleInteriorDesignCategoryStatus(categoryId, status);
            return response;
        } catch (error) {
            throw error;
        }
    };

    const getAllInteriorDesignCategories = async () => {
        try {
            const response = await Apis.getAllInteriorDesignCategories();
            return response.data.data;
        } catch (error) {
            throw error;
        }
    };

    const updateInteriorDesignCategoryPosition = async (categoryId, newPosition) => {
        try {
            const response = await Apis.updateInteriorDesignCategoryPosition({ categoryId, newPosition });
            return response;
        } catch (error) {
            throw error;
        }
    };

    return {
        addInteriorDesignCategory,
        getInteriorDesignCategories,
        getInteriorDesignCategoriesWithPagination,
        updateInteriorDesignCategory,
        deleteInteriorDesignCategory,
        toggleInteriorDesignCategoryStatus,
        getAllInteriorDesignCategories,
        updateInteriorDesignCategoryPosition
    }
}
